const withParticipants = participants => prevProject => ({
    ...prevProject,
    participants,
});

export default withParticipants;
